import type { CloudCostLine, CloudCostReport } from "@hasheeai/types";
import { t } from "../../i18n";
import { CostHelp } from "./CloudCostHelp";
import { costServiceLabel, costUnitLabel } from "./cloud-cost-labels";
import { usageStatus } from "./cloud-cost-service-month";
export function CostLineHelp({
  line,
  report,
}: { line: CloudCostLine; report: CloudCostReport }): React.JSX.Element {
  const values = lineDetails(line, report);
  return (
    <CostHelp title={costServiceLabel(line.service)}>
      <dl style={{ overflowWrap: "anywhere" }}>
        {values
          .filter((entry) => entry[1] != null)
          .map(([key, value]) => (
            <div key={`${key}:${value}`} style={{ margin: "10px 0" }}>
              <dt>{t(`cost.${key}`)}</dt>
              <dd style={{ marginLeft: 0 }}>{value}</dd>
            </div>
          ))}
      </dl>
    </CostHelp>
  );
}

function lineDetails(
  line: CloudCostLine,
  report: CloudCostReport,
): (string | undefined)[][] {
  return [
    ["resource_short", line.resource],
    ["plan_short", line.plan],
    ["basis", t(`cost.${line.basis}`)],
    ["billing_status", t(`cost.${usageStatus(line, report)}`)],
    [
      "unit_price_short",
      line.unit_price == null
        ? undefined
        : `${line.unit_price} ${line.currency} / ${costUnitLabel(line.unit)}`,
    ],
    [
      "billable_short",
      line.billable_quantity == null
        ? undefined
        : `${line.billable_quantity} ${costUnitLabel(line.unit)}`,
    ],
    [
      "reported_short",
      line.reported_amount == null
        ? undefined
        : `${line.reported_amount} ${line.currency}`,
    ],
    [
      "cumulative_short",
      line.cumulative_amount == null
        ? undefined
        : `${line.cumulative_amount} ${line.currency}`,
    ],
    [
      "billing_status",
      line.reconciliation === "mismatch"
        ? t("cost.amount_mismatch")
        : undefined,
    ],
    ["source_short", line.source],
  ];
}
